<ng-container *transloco="let t">
<div class="row">
  <div class="p-2 px-5 col-md-3">
    <div class="d-flex align-items-center mb-2">
      <div class="symbol symbol-40px symbol-lg-80px symbol-fixed position-relative me-4">
        <span class="svg-icon svg-icon-2x svg-icon-primary">
          <user-svg-icon></user-svg-icon>
        </span>
      </div>
      <a href="javascript:void(0)" (click)="onBorrowerInfoClicked()" class="text-gray-800 text-hover-primary fs-4 fw-bolder me-1">{{fullName}}</a>
      @if (isMainBorrower) {
        <span class="svg-icon svg-icon-1 svg-icon-success">
          <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
            <path d="M10.0813 3.7242C10.8849 2.16438 13.1151 2.16438 13.9187 3.7242V3.7242C14.4016 4.66147 15.4909 5.1127 16.4951 4.79139V4.79139C18.1663 4.25668 19.7433 5.83365 19.2086 7.50485V7.50485C18.8873 8.50905 19.3385 9.59842 20.2758 10.0813V10.0813C21.8356 10.8849 21.8356 13.1151 20.2758 13.9187V13.9187C19.3385 14.4016 18.8873 15.491 19.2086 16.4951V16.4951C19.7433 18.1663 18.1663 19.7433 16.4951 19.2086V19.2086C15.491 18.8873 14.4016 19.3385 13.9187 20.2758V20.2758C13.1151 21.8356 10.8849 21.8356 10.0813 20.2758V20.2758C9.59842 19.3385 8.50905 18.8873 7.50485 19.2086V19.2086C5.83365 19.7433 4.25668 18.1663 4.79139 16.4951V16.4951C5.1127 15.491 4.66147 14.4016 3.7242 13.9187V13.9187C2.16438 13.1151 2.16438 10.8849 3.7242 10.0813V10.0813C4.66147 9.59842 5.1127 8.50905 4.79139 7.50485V7.50485C4.25668 5.83365 5.83365 4.25668 7.50485 4.79139V4.79139C8.50905 5.1127 9.59842 4.66147 10.0813 3.7242V3.7242Z" fill="#00A3FF"></path>
            <path class="permanent" d="M14.8563 9.1903C15.0606 8.94984 15.3771 8.9385 15.6175 9.14289C15.858 9.34728 15.8229 9.66433 15.6185 9.9048L11.863 14.6558C11.6554 14.9001 11.2876 14.9258 11.048 14.7128L8.47656 12.4271C8.24068 12.2174 8.21944 11.8563 8.42911 11.6204C8.63877 11.3845 8.99996 11.3633 9.23583 11.5729L11.3706 13.4705L14.8563 9.1903Z" fill="white"></path>
          </svg>
        </span>
      }
    </div>
    @if (!detailsHidden) {
      <div class="fw-bold mb-4 pe-2">
        @if (isMainBorrower) {
          <span class="align-items-center text-gray-400 me-5 mb-2" style="display: block;">
            <span class="svg-icon svg-icon-4 me-1">
              <user-svg-icon></user-svg-icon>
            </span>
            {{ t('wizard.review.mainBorrower') }}
          </span>
        }
        <a href="javascript:void(0)" (click)="onBorrowerInfoClicked()" class="align-items-center text-gray-400 text-hover-primary me-5 mb-2" style="display: block;">
          <span class="svg-icon svg-icon-4 me-1">
            <duotone-map-marker-svg-icon></duotone-map-marker-svg-icon>
          </span>
          {{address}}</a>
        <a href="javascript:void(0)" (click)="onBorrowerInfoClicked()" class="align-items-center text-gray-400 text-hover-primary mb-2 fs-7">
          <span class="svg-icon svg-icon-4 me-1">
            <duotone-mail-svg-icon></duotone-mail-svg-icon>
          </span>
          {{email}}</a>
      </div>
    }
  </div>
  @if (!detailsHidden) {
    <div class="p-2 px-5 col-md-3" style="min-height: 146px;">
      <div class="mb-3">
        <div class="text-gray-800 fw-bold">{{ t('wizard.review.borrowerLabel') }}</div>
      </div>
      <div class="mb-3">
        <div class="text-gray-400 fw-bold">{{ t('wizard.review.phone') }}: <span class="text-gray-800 fw-bold">{{phoneNumber}}</span></div>
      </div>
      <div class="mb-3">
        <div class="text-gray-400 fw-bold">{{ t('wizard.review.maritalStatus') }}: <span class="text-gray-800 fw-bold">{{maritalStatus}}</span></div>
      </div>
      <div class="mb-3">
        <div class="text-gray-400 fw-bold">{{ t('wizard.review.address') }}: <span class="text-gray-800 fw-bold">{{address}}</span></div>
      </div>
    </div>
  }
  @if (!detailsHidden) {
    <div class="p-2 col-md-3 px-5" style="min-height: 146px;">
      <div class="mb-3">
        <div class="text-gray-800 fw-bold">{{ t('wizard.review.property') }}</div>
      </div>
      <div class="mb-3">
        <div class="text-gray-400 fw-bold">{{ t('wizard.review.type') }}: <span class="text-gray-800 fw-bold">{{propertyType}}</span></div>
      </div>
      <div class="mb-3">
        <div class="text-gray-400 fw-bold">{{ t('wizard.review.value') }}: <span class="text-gray-800 fw-bold">{{ purchasePrice | currency}}</span></div>
      </div>
    </div>
  }
  @if (!detailsHidden) {
    <div class="p-2 col-md-3 px-5" style="min-height: 146px;">
      <div class="mb-3">
        <div class="text-gray-800 fw-bold">{{ t('wizard.review.ownership') }}</div>
      </div>
      <div class="mb-3">
        <div class="text-gray-400 fw-bold">{{ t('wizard.review.status') }}: <span class="text-gray-800 fw-bold">{{residencyBasis}}</span></div>
      </div>
      <div class="mb-3">
        <div class="text-gray-400 fw-bold">{{ t('wizard.review.livedFor') }}: <span class="text-gray-800 fw-bold">{{residencyDuration}}</span></div>
      </div>
      @if (residencyBasis === 'Rent') {
        <div class="mb-3">
          <div class="text-gray-400 fw-bold">{{ t('wizard.review.rent') }}: <span class="text-gray-800 fw-bold">{{ rent | currency}}{{ t('wizard.review.perMonth') }}</span>
          </div>
        </div>
      }
      @if (residencyBasis === 'Own') {
        <div class="mb-3">
          <div class="text-gray-400 fw-bold">{{ t('wizard.review.payment') }}: <span class="text-gray-800 fw-bold">{{ monthlyPayment | currency}}{{ t('wizard.review.perMonth') }}</span>
          </div>
        </div>
      }
    </div>
  }
</div>
</ng-container>
